import styled from 'styled-components'

const HireSiderWrapper = styled.div`
    border-right: 1px solid rgb(240, 240, 240);
    height: 100%;
`

export {
    HireSiderWrapper
}